
  import axios from 'axios';
  import qs from 'qs';
  import { Component, Vue } from 'vue-property-decorator';

  import InviteList from './List.vue';
  import Actions from './Actions.vue';
  import FilterPanel from './FilterPanel.vue';
  // import Pagination from '@/components/shared/Pagination.vue';
  import Navigation from '@/components/Navigation.vue';
  import MessageSend from '@/components/modals/MessageSend.vue';

  @Component({
    name: 'InvitesScene',
    components: {
      Actions,
      InviteList,
      // Pagination,
      Navigation,
      FilterPanel,
      MessageSend
    }
  })
  export default class InvitesScene extends Vue {
    private pendingSpinner = false;
    private loading_more = false;
    private filter_temp_selected_statuses = [];
    private filter_temp_selected_vacancy = [];
    private filter_temp_dates = [];
    private filter_temp_selected_creators = [];
    private temp_name = '';
    private temp_phone = '';
    private temp_email = '';
    private show_filter = 'none';
    private filter_loaded = false;
    private filter_statuses = [];
    private filter_vacancies = [];
    private filter_creators = [];
    private isMessageSendShown = false;

    get filters() {
      return this.$store.getters['invites/filters'];
    }

    get filter() {
      return this.$store.getters['invites/filter'];
    }

    get invitesWithResponseIds() {
      if (!this.invites || !this.invites.length) {
        return [];
      }

      const newInvitesArray = [...this.invites];
      return newInvitesArray.map(invite => {
        return Object.assign({}, invite, {
          id: invite.response.id,
          email: invite.candidate.email
        });
      });
    }

    get selectedInvites() {
      const newInvitesArray = this.$store.getters['invites/selectedList'];
      if (!newInvitesArray || !newInvitesArray.length) {
        return [];
      }
      return newInvitesArray.map(invite => {
        return Object.assign({}, invite, {
          id: invite.response.id,
          inviteId: invite.id,
          email: invite.candidate.email
        });
      });
    }

    get hasInvitesRoleRead() {
      if (!this.selectedInvites && !this.invites) {
        return false;
      }

      if (this.selectedInvites.length) {
        let isRoleRead = false;

        this.selectedInvites.forEach(invite => {
          if (invite.vacancy && invite.vacancy.role === 'role_read') {
            isRoleRead = true;
          }
        });

        return isRoleRead;
      }

      if (this.invites.length) {
        let isRoleRead = true;

        this.invites.forEach(invite => {
          if (invite.vacancy && invite.vacancy.role !== 'role_read') {
            isRoleRead = false;
          }
        });

        return isRoleRead;
      }
    }

    get error() {
      return this.$store.getters['invites/error'];
    }

    get navigationLinks() {
      return [
        { to: '/vacancies', label: this.$tr('vacancies.title') },
        { to: '/invitations', label: this.$tr('invites.title') },
        { to: '/responses', label: this.$tr('responses.title') }
      ];
    }

    get loading() {
      return this.$store.getters['invites/loading'];
    }

    get invites() {
      return this.$store.getters['invites/list'];
    }

    get paginationParams() {
      return this.$store.getters['invites/pagination'];
    }

    get filter() {
      return this.$store.getters['invites/filter'];
    }

    get filter_query() {
      return this.$store.getters['invites/filter_query'];
    }

    public changeSendMessageDisplay() {
      this.isMessageSendShown = !this.isMessageSendShown;
    }
    public load_more(is_active = true) {
      this.loading_more = true;
      this.$store
        .dispatch('invites/load_more', is_active)
        .then(r => {
          this.loading_more = false;
        })
        .catch(e => {
          this.loading_more = false;
        });
    }
    public fetch() {
      this.$store.dispatch('invites/fetch').then(() => {
        this.loadFilters();
      });
    }
    public fetchStatuses() {
      this.$store.dispatch('dictionary/fetchStagesAndStatuses');
    }

    public fetch_invites(is_load_more = false) {
      this.$store.commit('invites/set_load_more', is_load_more);
      this.$store.dispatch('invites/fetch');
    }

    public change_count(val) {
      this.$store.commit('invites/change_count', val);
      this.fetch_invites();
    }

    public handleExportInvites(filter = null) {
      this.pendingSpinner = !this.pendingSpinner;

      let params = {};

      if (this.filter.name) {
        params.name = this.filter.name;
      }

      if (this.filter.email) {
        params.email = this.filter.email;
      }

      if (this.filter.phone) {
        params.phone = this.filter.phone;
      }

      if (this.filters.responseStatusId) {
        params = {
          ...params,
          response_status_id: this.filters.responseStatusId
        };
      }

      if (this.selectedInvites && this.selectedInvites.length) {
        params.ids = this.selectedInvites.map(i => i.inviteId);
      }

      if (this.filters.vacancyId) {
        params = {
          ...params,
          vacancy: this.filters.vacancyId
        };
      }

      if (this.filter_query !== null) {
        params.filter = this.filter_query;
      }
      if (filter !== null) {
        params.filter = filter;
      }

      this.$store.getters['situation/api/invitesAPI']
        .getExcelImportLink(params)
        .then(() => {
          this.pendingSpinner = false;
        })
        .catch(err => {
          this.$store.dispatch('global/setError', err);
          this.pendingSpinner = false;
        });
      this.$noty.success(this.$tr('invites.exportToExcelSuccess'));
    }

    public onPageChange(pageNumber) {
      this.$store.commit('invites/updatePagination', {
        pageNumber
      });

      this.fetch();
    }

    public onLimitChange(count) {
      this.$store.commit('invites/updatePagination', {
        count
      });

      this.fetch();
    }

    public vacancySelect(val) {
      const vacancy = val.id === 0 ? null : val.id;
      if (vacancy) {
        this.set_show_filter('none');
        this.set_filter_temp_selected_vacancy([vacancy]);
        this.apply_filter('vacancy_id');
      } else {
        this.vacancy_clear();
      }
    }

    public setStatus(status) {
      const status_id = status ? status.id : null;
      if (status_id) {
        this.set_show_filter('none');
        this.set_filter_temp_selected_statuses([status_id]);
        this.apply_filter('status_id');
      } else {
        this.status_clear();
      }
    }

    public set_filter_temp_selected_statuses(arr) {
      this.filter_temp_selected_statuses = arr;
    }
    public set_filter_temp_selected_vacancy(arr) {
      this.filter_temp_selected_vacancy = arr;
    }
    public set_filter_temp_dates(arr) {
      this.filter_temp_dates = arr;
    }
    public set_filter_temp_selected_creators(arr) {
      this.filter_temp_selected_creators = arr;
    }
    public set_temp_name(name) {
      this.temp_name = name;
    }
    public set_temp_phone(phone) {
      this.temp_phone = phone.replace(/ /g, '');
    }
    public set_temp_email(email) {
      this.temp_email = email;
    }

    public loadFilters() {
      axios
        .get('/v2/invite-filters', {
          params: { filter: this.filter_query },
          paramsSerializer: params => {
            return qs.stringify(params);
          }
        })
        .then(r => {
          this.filter_loaded = true;
          this.filter_temp_dates = r.data
            .filter(i => i.id === 'date_created')[0]
            .list.map(i => i.id);
          this.filter_creators = r.data.filter(i => i.id === 'user_id')[0].list;
          this.filter_vacancies = r.data.filter(i => i.id === 'vacancy_id')[0].list;
          this.filter_statuses = r.data.filter(i => i.id === 'status_id')[0].list;
        });
    }

    public apply_filter(filter) {
      let query_filter = [...this.filter.query_filter];
      if (query_filter.indexOf(filter) === -1) {
        query_filter.push(filter);
      }
      this.$store.commit('invites/set_filter', { key: 'query_filter', v: query_filter });
      this.$store.commit('invites/set_filter', {
        key: 'vacancy_id',
        v: this.filter_temp_selected_vacancy
      });
      this.$store.commit('invites/set_filter', { key: 'name', v: this.temp_name });
      this.$store.commit('invites/set_filter', {
        key: 'phone',
        v: this.temp_phone.replace(/ /g, '')
      });
      this.$store.commit('invites/set_filter', { key: 'email', v: this.temp_email });
      this.$store.commit('invites/set_filter', {
        key: 'status_id',
        v: this.filter_temp_selected_statuses
      });
      this.$store.commit('invites/set_filter', { key: 'date_created', v: this.filter_temp_dates });
      this.$store.commit('invites/set_filter', {
        key: 'user_id',
        v: this.filter_temp_selected_creators
      });
      this.set_show_filter('none');

      this.$store.commit('invites/updatePagination', {
        pageNumber: 1
      });

      this.fetch();
    }
    public cancel_filter() {
      this.filter_temp_selected_statuses = this.filter.status_id;
      this.filter_temp_selected_vacancy = this.filter.vacancy_id;
      this.temp_name = this.filter.name;
      this.temp_phone = this.filter.phone;
      this.temp_email = this.filter.email;
      this.filter_temp_dates = this.filter.date_created;
      this.filter_temp_selected_creators = this.filter.user_id;
      this.set_show_filter('none');
    }
    public status_clear() {
      let query_filter = this.filter.query_filter.filter(i => i !== 'status_id');
      this.$store.commit('invites/set_filter', { key: 'query_filter', v: query_filter });
      this.filter_temp_selected_statuses = [];
      this.$store.commit('invites/set_filter', { key: 'status_id', v: [] });
      this.set_show_filter('none');

      this.$store.commit('invites/updatePagination', {
        pageNumber: 1
      });

      this.fetch();
    }
    public vacancy_clear() {
      let query_filter = this.filter.query_filter.filter(i => i !== 'vacancy_id');
      this.$store.commit('invites/set_filter', { key: 'query_filter', v: query_filter });
      this.filter_temp_selected_vacancy = [];
      this.$store.commit('invites/set_filter', { key: 'vacancy_id', v: [] });
      this.set_show_filter('none');

      this.$store.commit('invites/updatePagination', {
        pageNumber: 1
      });

      this.fetch();
    }
    public date_clear() {
      let query_filter = this.filter.query_filter.filter(i => i !== 'date_created');
      this.$store.commit('invites/set_filter', { key: 'query_filter', v: query_filter });
      this.filter_temp_dates = [];
      this.$store.commit('invites/set_filter', { key: 'date_created', v: [] });
      this.set_show_filter('none');

      this.$store.commit('invites/updatePagination', {
        pageNumber: 1
      });

      this.fetch();
    }
    public name_clear() {
      let query_filter = this.filter.query_filter.filter(i => i !== 'name');
      this.$store.commit('invites/set_filter', { key: 'query_filter', v: query_filter });
      this.temp_name = '';
      this.$store.commit('invites/set_filter', { key: 'name', v: '' });
      this.set_show_filter('none');

      this.$store.commit('invites/updatePagination', {
        pageNumber: 1
      });

      this.fetch();
    }
    public phone_clear() {
      let query_filter = this.filter.query_filter.filter(i => i !== 'phone');
      this.$store.commit('invites/set_filter', { key: 'query_filter', v: query_filter });
      this.temp_phone = '';
      this.$store.commit('invites/set_filter', { key: 'phone', v: '' });
      this.set_show_filter('none');

      this.$store.commit('invites/updatePagination', {
        pageNumber: 1
      });

      this.fetch();
    }
    public email_clear() {
      let query_filter = this.filter.query_filter.filter(i => i !== 'email');
      this.$store.commit('invites/set_filter', { key: 'query_filter', v: query_filter });
      this.temp_name = '';
      this.$store.commit('invites/set_filter', { key: 'email', v: '' });
      this.set_show_filter('none');

      this.$store.commit('invites/updatePagination', {
        pageNumber: 1
      });

      this.fetch();
    }
    public creator_clear() {
      let query_filter = this.filter.query_filter.filter(i => i !== 'user_id');
      this.$store.commit('invites/set_filter', { key: 'query_filter', v: query_filter });
      this.filter_temp_selected_creators = [];
      this.$store.commit('invites/set_filter', { key: 'user_id', v: [] });
      this.set_show_filter('none');

      this.$store.commit('invites/updatePagination', {
        pageNumber: 1
      });

      this.fetch();
    }
    public set_show_filter(v) {
      this.show_filter = v;
      this.filter_temp_selected_statuses = this.filter.status_id;
      this.filter_temp_selected_vacancy = this.filter.vacancy_id;
      this.filter_temp_dates = this.filter.date_created;
      this.filter_temp_selected_creators = this.filter.user_id;
    }

    beforeMount() {
      this.fetch();
      this.fetchStatuses();
    }

    beforeDestroy() {
      // DO NOT do this (!), because it calls after before mount of new component, and could possible clear corect active process value
      // this.$store.dispatch('activeProcess/clearActiveProcess')
    }
  }
